import { useMemo } from 'react'

import EntitiesSelector from './EntitiesSelector'
import { useSelector } from 'react-redux'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { StudentStatusLabels } from '../../../utils/entities/student'

const StudentStatusSelector = ({ className = '', disabled, multiple = 'default', style = {}, values, onChange }) => {
  const t = useSelector(selectTranslate)

  const studentStatusOptions = useMemo(() => StudentStatusLabels.map(status => ({
    label: t('student_status_codes.' + status.toLowerCase()),
    value: status
  })), [t])

  return (
    <EntitiesSelector
      className={className}
      disabled={disabled}
      entityOptions={studentStatusOptions}
      multiple={multiple}
      showSearch
      style={style}
      values={values}
      onChange={onChange}
    />
  )
}

export default StudentStatusSelector
